'use client';
import dynamic from 'next/dynamic';
import { PrivyAuthProvider } from './privy-auth-provider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SocketClientProvider from './socket-client-provider';

const AccountProvider = dynamic(
  () =>
    import('./account-provider').then(({ AccountProvider }) => AccountProvider),
  {
    ssr: false,
  }
);

const OnChainSyncProvider = dynamic(
  () =>
    import('./onchain-sync-provider').then(
      ({ OnchainSyncProvider }) => OnchainSyncProvider
    ),
  {
    ssr: false,
  }
);
const AccountNameProvider = dynamic(
  () =>
    import('./account-name-provider').then(
      ({ AccountNameProvider }) => AccountNameProvider
    ),
  {
    ssr: false,
  }
);

const GunStorageProvider = dynamic(
  () =>
    import('./gun-storage-provider').then(
      ({ GunStorageProvider }) => GunStorageProvider
    ),
  {
    ssr: false,
  }
);

const DdocListProvider = dynamic(
  () =>
    import('./ddoc-list-provider').then(
      ({ DdocListProvider }) => DdocListProvider
    ),
  {
    ssr: false,
  }
);

const queryClient = new QueryClient();

export const GlobalProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <PrivyAuthProvider>
        <AccountProvider>
          <GunStorageProvider>
            <DdocListProvider>
              <SocketClientProvider>
                <OnChainSyncProvider>
                  <AccountNameProvider>{children}</AccountNameProvider>
                </OnChainSyncProvider>
              </SocketClientProvider>
            </DdocListProvider>
          </GunStorageProvider>
        </AccountProvider>
      </PrivyAuthProvider>
    </QueryClientProvider>
  );
};
